import { render, staticRenderFns } from "./vsSidebar.vue?vue&type=template&id=32764bfa&"
import script from "./vsSidebar.vue?vue&type=script&lang=js&"
export * from "./vsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsSidebar.vue"
export default component.exports